module.exports = __webpack_public_path__ + "static/media/_space_green.45d8ee19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_space_green.jpg
// module id = 46
// module chunks = 0